import { RoutePath } from "#src/utils/route";
import { FormCategoryDetailsRoute } from "../..";

export const linkToFormTemplateDetail = (
  formCategoryId = ":categoryId",
  formTemplateId = ":formTemplateId"
) => `/app/forms/categories/${formCategoryId}/templates/${formTemplateId}`;

export const FORM_TEMPLATE_DETAILS_BREADCRUMB = {
  title: "Form Template:categoryId:formTemplateId",
  path: linkToFormTemplateDetail,
};

export const FormTemplateDetailsRoute = FormCategoryDetailsRoute.concat(
  new RoutePath<"formTemplateId">({
    path: "/templates/:formTemplateId",
    title: "Form Template Details",
  })
);
